import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, PopoverController } from '@ionic/angular';

@Component({
  selector: 'nova-notification-popover',
  standalone: true,
  imports: [CommonModule, IonicModule],
  template: `
    <div class="nova-notification">
      <div class="notification-header">
        <ion-icon name="analytics-outline" class="nova-icon"></ion-icon>
        <h3>{{ heading }}</h3>
      </div>
      <p>{{ notificationText }}</p>
      <div class="notification-actions">
        <button class="btn-primary" (click)="onShowMe()">{{ mainButtonText }}</button>
        <button class="btn-secondary" (click)="onMaybeLater()">{{ secondaryButtonText }}</button>
      </div>
    </div>
  `,
  styles: [`
    .nova-notification {
      padding: 16px;
      background: #0a0e27;
      color: rgba(255, 255, 255, 0.9);
      border-radius: 12px;
      min-width: 280px;
    }
    .notification-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;
    }
    .nova-icon {
      font-size: 20px;
      color: #00c9a7;
    }
    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #fff;
    }
    p {
      margin: 0 0 16px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 1.5;
    }
    .notification-actions {
      display: flex;
      gap: 8px;
    }
    .btn-primary {
      flex: 1;
      padding: 10px;
      border-radius: 8px;
      border: none;
      background: linear-gradient(135deg, #00c9a7 0%, #00b4d8 100%);
      color: #0a0e27;
      font-size: 14px;
      font-weight: 600;
      cursor: pointer;
    }
    .btn-secondary {
      flex: 1;
      padding: 10px;
      border-radius: 8px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      background: transparent;
      color: rgba(255, 255, 255, 0.7);
      font-size: 14px;
      cursor: pointer;
    }
  `],
})
export class NovaNotificationPopoverComponent {
  @Input() heading: string = 'Ask-Nova Voice';
  @Input() notificationText: string = '';
  @Input() mainButtonText: string = 'Show Me';
  @Input() secondaryButtonText: string = 'Maybe Later';

  constructor(private popoverCtrl: PopoverController) {}

  onShowMe() {
    this.popoverCtrl.dismiss({ viewAnalysis: true });
  }

  onMaybeLater() {
    this.popoverCtrl.dismiss({ viewAnalysis: false });
  }
}
